import axios from 'axios'
import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
const url = {
  getAllStudents:root+"/Student/getAllStudents",//个人中心 获取全部孩子信息

  ChangePass:root+"/Base/ChangePass",//个人中心->修改密码信息
  getChangePassCode:root+"/Base/getChangePassCode",//个人中心->修改密码获取验证码
  isTrueofCode:root+"/Base/isTrueofCode",//个人中心->修改密码验证验证码是否正确

  Switch:root+"/Base/Switch",//个人中心->切换宝宝->验证密码
  getSwitchBabyCode:root+"/Base/getSwitchBabyCode",//个人中心->切换宝宝->获取验证码
  isTrueofSwitchBabyCode:root+"/Base/isTrueofSwitchBabyCode",//个人中心->切换宝宝->验证验证码
  getOneStudent:root+"/Student/getOneStudent",//个人中心->获取单个孩子信息--zjb

  lrDGSource:root+"/Student/lrDGSource",//个人中心->学习记录->金币钻石来源--zjb
  lrTasklog:root+"/Student/lrTasklog",//个人中心->学习记录->课时丶任务丶测评等数量 --zjb
  lrLearnDetail:root+"/Student/lrLearnDetail",//个人中心->学习轨迹
}
const myCenterStore =  {
  // 个人中心 获取全部孩子信息
  getAllStudents(params){
    return axios.get(url.getAllStudents,{ params })
  },
   //个人中心->修改密码信息
   ChangePass(params) {
    return axios.post(url.ChangePass, qs.stringify(params))
  },
  //个人中心->修改密码获取验证码
  getChangePassCode(params){
    return axios.get(url.getChangePassCode,{ params })
  },
   //个人中心->修改密码验证验证码是否正确
   isTrueofCode(params) {
    return axios.post(url.isTrueofCode, qs.stringify(params))
  },

  //个人中心->切换宝宝->验证密码
  Switch(params){
    return axios.get(url.Switch,{ params })
  },
  // 个人中心->切换宝宝->获取验证码
  getSwitchBabyCode(params){
    return axios.get(url.getSwitchBabyCode,{ params })
  },
  //个人中心->切换宝宝->验证验证码
  isTrueofSwitchBabyCode(params) {
    return axios.post(url.isTrueofSwitchBabyCode, qs.stringify(params))
  },
   // 个人中心->获取单个孩子信息-
   getOneStudent(params){
    return axios.get(url.getOneStudent,{ params })
  },
  // 个人中心->学习记录->金币钻石来源--zjb
  lrDGSource(params){
    return axios.get(url.lrDGSource,{ params })
  },
  // 个人中心->学习记录->课时丶任务丶测评等数量 --zjb
  lrTasklog(params){
    return axios.get(url.lrTasklog,{ params })
  },
  // 个人中心->学习轨迹
  lrLearnDetail(params){
    return axios.get(url.lrLearnDetail,{ params })
  },
}

export default myCenterStore;